import { convertVariations } from '../variations/convert';
import { setProfileErrors } from '../validations/profile';
import { getTagError } from '../validations/tags';

import { MAX_NUMBER_OF_TAGS } from '../../constants/validations';
import { ETSY, SHOPIFY } from '../../constants/channels';
import { CATEGORY } from '../../constants/attributes';
import { PROFILE } from '../../constants/profiles';
import { AMOUNT } from '../../constants/product';

function convertTagsProfile({ channel, profile }) {
  function filterTags(tag) {
    return !getTagError({ channel, tag });
  }

  const tags = profile.get('tags').filter(filterTags);

  return profile
    .set('tags', tags)
    .set('channel', channel)
    .set('invalid', tags.size > MAX_NUMBER_OF_TAGS[channel]);
}

function convertSalesProfile({ channel, profile }) {
  if (profile.get('channel') === channel) return profile;

  switch (channel) {
    case ETSY: {
      return profile.delete('isConvertPriceToCap', false);
    }

    case SHOPIFY: {
      return profile.set('isConvertPriceToCap', false);
    }

    default:
      return profile;
  }
}

function convertVariationsProfile({ channel: to, profile }) {
  const from = profile.get('channel');
  const title = profile.get('title');
  const category = profile.get(CATEGORY);
  const variations = profile.set('channel', to).set('listingsCount', 0);
  const result = convertVariations({ category, from, to, validate: false, variations }).set('title', title);

  switch (from) {
    case ETSY: {
      switch (to) {
        case ETSY: {
          return setProfileErrors({ profile: result.set(CATEGORY, category), type: PROFILE.VARIATIONS });
        }

        default: {
          return result;
        }
      }
    }

    case SHOPIFY: {
      switch (to) {
        case ETSY: {
          return setProfileErrors({ profile: result.set(CATEGORY, AMOUNT.ZERO), type: PROFILE.VARIATIONS });
        }

        default: {
          return result;
        }
      }
    }

    default: {
      return result;
    }
  }
}

export function convertProfile({ channel, profile, type }) {
  switch (type) {
    case PROFILE.VARIATIONS: {
      return convertVariationsProfile({ channel, profile });
    }

    case PROFILE.TAGS: {
      return convertTagsProfile({ channel, profile });
    }

    case PROFILE.SALES: {
      return convertSalesProfile({ channel, profile });
    }

    default: {
      return profile;
    }
  }
}
